<template>
<div>
  <v-flex xs10 offset-xs1>
    <div class='fl hf mb-5' style='align-items: flex-end;'>
      <div class='golden-left'>
        <h1 class='mb-4'>{{ 'employees.overview' | translate }}</h1>
        <p>{{ 'employees.index-title' | translate }}</p>
      </div>
      <div class='golden-right fl' style='position: relative; top: -28px;'>
        <!--
          <import-employees-card-button class='mr-4' />
          <new-employee-card-button @click="handleOpenNewTab" />
        -->
      </div>
    </div>

    <div class='hf'>
      <div class='hf aic fl mb-5'>
        <TextField :placeholder="$t('input.placeholders.who-are-you-looking-for')" class="golden-left" v-model="search">
          <v-icon slot='left'>search</v-icon>
        </TextField>

        <div class='fl ml-3' style='position: relative; top: 2px;'>
          <radio-group-item small gray
            :selected="noneFilter"
            v-on:click.native="noneFilter = !noneFilter"
            class='mr-3'
            style='min-width: 66%'>Zonder polis</radio-group-item>

          <radio-group-item small tertiary
            :selected="vzmFilter"
            v-on:click.native="vzmFilter = !vzmFilter"
            class='mr-3'
            style='min-width: 42%'>Verzuim</radio-group-item>

          <radio-group-item small secondary
            :selected="wiaFilter"
            v-on:click.native="wiaFilter = !wiaFilter"
            style='min-width: 31%'>WIA</radio-group-item>
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="employees"
        :loading="isLoading"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="[5, 10, 25, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]"
        rows-per-page-text='Rijen per pagina'>
        <v-progress-linear slot='progress' color='#cdd2dc' indeterminate></v-progress-linear>
        <template slot='items' slot-scope='props'>
        <tr @click="() => handleSelectEmployee(props.item)"
            style='cursor: pointer;'>
            <td>{{ props.item.initials }}</td>
            <td>{{ props.item.middleName }} {{ props.item.lastName }}</td>
            <td>{{ props.item.middleNamePartner }} {{props.item.lastNamePartner}}</td>
            <td>{{ getFormattedDate(props.item.dateOfBirth) }}</td>
            <td>{{ props.item.gender | translate }}</td>
            <td>{{ props.item.employeeNumber }}</td>
            <td style='display: none'>{{ props.item.search }}</td>
            <td>
              <PolicyTypeBadge v-for="(pt, i) in getPolicyTypeForEmployee(props.item)"
                :key="i + pt + props.item.id" :policyType="pt" class='mr-2' />
            </td>
          </tr>
        </template>

        <div class='no-results-badge' slot='no-results'>
          <v-icon>warning</v-icon>
          <p>{{ 'errors.no-results-found' | translate }}
            <span>{{ search }}</span>.
          </p>
        </div>

        <div class="no-results-badge" slot="no-data">
          <p>{{ 'errors.no-data-found' | translate }}</p>
        </div>
      </v-data-table>
    </div>
  </v-flex>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';

import HelperFunctions from '@/shared/helpers/functions';
import Compositions from '@/views/helpers/compositions';

import RadioGroupItem from '@aevitae/aevitaeui/0_atoms/input/RadioGroupItem.vue';

// import EmployeesResource from '@/resources/constants/employees';
import EmployeesView from '@/views/constants/employees';

import PolicyTypeBadge from '@/views/components/policies/PolicyTypeBadge.vue';
// import NewEmployeeCardButton from '@/views/components/generic/NewEmployeeCardButton.vue';
// import ImportEmployeesCardButton from '@/views/components/generic/ImportEmployeesCardButton.vue';

export default {
  name: 'EmployeesIndex',
  components: {
    TextField,
    PolicyTypeBadge,
    RadioGroupItem
    // NewEmployeeCardButton,
    // ImportEmployeesCardButton
  },
  data () {
    return {
      headers: [
        { text: this.$t('employee.initials'), value: 'initials' },
        { text: this.$t('employee.last-name'), value: 'lastName' },
        { text: this.$t('employee.last-name-partner'), value: 'middleName' },
        { text: this.$t('employee.date-of-birth'), value: 'dateOfBirth' },
        { text: this.$t('employee.gender'), value: 'gender' },
        { text: this.$t('employee.id'), value: 'employeeNumber' },
        { text: 'Polis ', value: 'policyTypesIndicator' },
        { text: '', value: 'search', width: '0px' }
      ]
    };
  },
  mounted () {
    /*
    if (this.$store.getters.selectedEmployer != null) {
      this.$store.dispatch(EmployeesResource.Actions.LoadAll.START,
        this.$store.getters.selectedEmployer.id);
    } */
  },
  computed: {
    ...mapGetters({
      isLoading: 'isEmployeesLoading',
      policies: 'activePolicies',
      filters: 'employeesIndexFilters'
    }),
    search: {
      get () { return this.filters.search; },
      set (v) { this.changeFilter('search', v); }
    },
    noneFilter: {
      get () { return this.filters.noneFilter; },
      set (v) { this.changeFilter('noneFilter', v); }
    },
    vzmFilter: {
      get () { return this.filters.vzmFilter; },
      set (v) { this.changeFilter('vzmFilter', v); }
    },
    wiaFilter: {
      get () { return this.filters.wiaFilter; },
      set (v) { this.changeFilter('wiaFilter', v); }
    },
    pagination: {
      get () { return this.filters.pagination; },
      set (v) { this.changeFilter('pagination', v); }
    },
    employees () {
      const employees = this.$store.getters.employees;

      let result = [];
      employees.forEach(e => {
        let policyTypes = this.getPolicyTypeForEmployee(e);

        let hasWia = policyTypes.indexOf('WIA') > -1;
        let hasVzm = policyTypes.indexOf('VZM') > -1;

        if ((this.wiaFilter && hasWia) || (this.vzmFilter && hasVzm) || (this.noneFilter && (!hasWia && !hasVzm))) {
          e.search = e.getSearchString(0);
          e.policyTypesIndicator = policyTypes.indexOf('WIA') + policyTypes.indexOf('VZM');
          result.push(e);
        }
      });
      return result;
    }
  },
  methods: {
    getFormattedDate: value => HelperFunctions.Dates.formatDate(value),

    handleSelectEmployee (employee) {
      this.$store.dispatch(EmployeesView.Actions.Details.OPEN, employee);
    },

    changeFilter (filter, value) {
      this.$store.dispatch(EmployeesView.Actions.CHANGE_INDEX_FILTER, {
        filter: filter,
        value: value
      });
    },

    getPolicyTypeForEmployee (employee) {
      return Compositions.getEmployeePolicyTypes(employee, this.policies);
    },

    handleOpenNewTab () {
      this.$store.dispatch(EmployeesView.Actions.New.OPEN);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
